import { assignmentTypes } from "../../../constants/constants";

export default function getActivityType(type, tags) {
    if (type === "assessment") {
      if (tags && tags.includes("BENCHMARK")) return "Assessment";
      else return "Progress Monitor";
    }
    if (type === assignmentTypes.LETTER_NAMING_AND_SOUNDS) {
      return "Letter Names and Sounds"
    }
    return type[0].toUpperCase() + type.slice(1)
  }

export function isBenchmarkAssessment(activity) {
  if (!activity) return false;
  return activity?.type === "assessment" && activity?.tags?.includes("BENCHMARK");
}